// extracted by mini-css-extract-plugin
export default {"button":"button_button__4-vvU","disabled":"button_disabled__wtrq3","loading":"button_loading__AALtY"};